"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _Link = _interopRequireDefault(require("@sprinx/react-mui-components/Link"));

var _pickReactKnownProp = require("pick-react-known-prop");

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Skeleton = _interopRequireDefault(require("@material-ui/lab/Skeleton"));

var _useBannerSizeCode = _interopRequireDefault(require("../useBannerSizeCode"));

var _useBanners = _interopRequireDefault(require("../useBanners"));

var _MediaSelectorBanner = _interopRequireDefault(require("../MediaSelectorBanner"));

//
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      overflow: 'hidden',
      width: '100%',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3)
    },
    banner: {
      alignSelf: 'center',
      margin: '0 auto',
      maxWidth: '100%',
      height: '100%'
    },
    'banner-square': {
      width: 250,
      maxHeight: 250
    },
    'banner-small-square': {
      width: 200,
      maxHeight: 200
    },
    'banner-banner': {
      width: 468,
      maxHeight: 60
    },
    'banner-leaderboard': {
      width: 728,
      maxHeight: 90
    },
    'banner-inline-rectangle': {
      width: 300,
      maxHeight: 250
    },
    'banner-large-rectangle': {
      width: 336,
      maxHeight: 280
    },
    'banner-skyscraper': {
      width: 120,
      maxHeight: 600
    },
    'banner-wide-skyscraper': {
      width: 160,
      maxHeight: 600
    },
    'banner-half-page-ad': {
      width: 300,
      maxHeight: 600
    },
    'banner-large-leaderboard': {
      width: 970,
      maxHeight: 90
    },
    bannerImage: {
      width: '100%',
      height: '100%'
    },
    skeleton: (0, _defineProperty2.default)({
      maxHeight: 329,
      width: 1232,
      height: 'calc(100vw / 7.56)'
    }, theme.breakpoints.down('xs'), {
      height: 'calc(100vw / 1.32)',
      maxHeight: 676.6
    }),
    box: {
      display: 'flex',
      flexGrow: 1
    }
  };
}, {
  name: 'SxWebBannerPosition'
});

var Skeleton = function Skeleton(_ref) {
  var hideSkeleton = _ref.hideSkeleton;
  var classes = useStyles();
  return !hideSkeleton ? /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: classes.box
  }, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: "rect",
    className: classes.skeleton,
    animation: "wave"
  })) : null;
};

process.env.NODE_ENV !== "production" ? Skeleton.propTypes = {
  hideSkeleton: _propTypes.default.bool
} : void 0;
Skeleton.defaultProps = {
  hideSkeleton: false
};

function BannerPosition(_ref2) {
  var pClasses = _ref2.classes,
      className = _ref2.className,
      hideSkeleton = _ref2.hideSkeleton,
      position = _ref2.position,
      sizes = _ref2.sizes,
      rest = (0, _objectWithoutProperties2.default)(_ref2, ["classes", "className", "hideSkeleton", "position", "sizes"]);
  var classes = useStyles({
    classes: pClasses
  });
  var bannerSizeCode = (0, _useBannerSizeCode.default)(sizes);
  var banners = (0, _useBanners.default)(position, bannerSizeCode);

  var currentBanner = _react.default.useMemo(function () {
    return banners ? banners[0] : null;
  }, [banners]);

  var _ref3 = currentBanner || {},
      media = _ref3.media;

  var Wrapper = currentBanner && currentBanner.href ? function (p) {
    return /*#__PURE__*/_react.default.createElement(_Link.default, (0, _extends2.default)({}, p, {
      to: currentBanner.href
    }));
  } : function (_ref4) {
    var c = _ref4.children;
    return c;
  };
  return typeof media !== 'undefined' && (media === null || media === void 0 ? void 0 : media.length) > 0 ? /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: (0, _clsx.default)(classes.banner, bannerSizeCode && classes["banner-".concat(bannerSizeCode)])
  }, /*#__PURE__*/_react.default.createElement(_MediaSelectorBanner.default, {
    src: media[0].src,
    alt: media[0].alt,
    href: media[0].href,
    size: bannerSizeCode,
    type: media[0].type // className={clsx(classes.banner, bannerSizeCode ? classes[`banner-${bannerSizeCode}`] : null)}
    ,
    className: (0, _clsx.default)(classes.bannerImage, className)
  }))) : /*#__PURE__*/_react.default.createElement(Skeleton, {
    hideSkeleton: hideSkeleton
  });
}

process.env.NODE_ENV !== "production" ? BannerPosition.propTypes = {
  classes: _propTypes.default.shape({
    banner: _propTypes.default.string,
    bannerImage: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  hideSkeleton: _propTypes.default.bool,
  position: _propTypes.default.string.isRequired,
  sizes: _propTypes.default.shape({
    lg: _propTypes.default.oneOf(['square', 'small-square', 'banner', 'leaderboard', 'inline-rectangle', 'large-rectangle', 'skyscraper', 'wide-skyscraper', 'half-page-ad', 'large-leaderboard']),
    md: _propTypes.default.oneOf(['square', 'small-square', 'banner', 'leaderboard', 'inline-rectangle', 'large-rectangle', 'skyscraper', 'wide-skyscraper', 'half-page-ad', 'large-leaderboard']),
    sm: _propTypes.default.oneOf(['square', 'small-square', 'banner', 'leaderboard', 'inline-rectangle', 'large-rectangle', 'skyscraper', 'wide-skyscraper', 'half-page-ad', 'large-leaderboard']),
    xl: _propTypes.default.oneOf(['square', 'small-square', 'banner', 'leaderboard', 'inline-rectangle', 'large-rectangle', 'skyscraper', 'wide-skyscraper', 'half-page-ad', 'large-leaderboard']),
    xs: _propTypes.default.oneOf(['square', 'small-square', 'banner', 'leaderboard', 'inline-rectangle', 'large-rectangle', 'skyscraper', 'wide-skyscraper', 'half-page-ad', 'large-leaderboard'])
  })
} : void 0;
BannerPosition.defaultProps = {
  classes: undefined,
  className: undefined,
  hideSkeleton: false,
  sizes: undefined
};
var _default = BannerPosition;
exports.default = _default;